import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { name: "", category: "Things to Do", description: "", distance: "", address: "", website: "", image_url: "" };

export default function AdminAttractions() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/attractions").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/attractions", form);
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/attractions/${id}`); load(); };

  return (
    <div data-testid="admin-attractions">
      <div className="section-label">Nearby</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Local Attractions</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <input data-testid="att-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <select data-testid="att-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border border-slate-300 px-3 py-2 bg-white">
          <option>Things to Do</option>
          <option>Outdoor</option>
          <option>Dining</option>
          <option>Lodging</option>
        </select>
        <input data-testid="att-distance" placeholder="Distance (e.g., ~15 min drive)" value={form.distance} onChange={(e) => setForm({ ...form, distance: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="att-address" placeholder="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="att-website" placeholder="Website URL" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <input data-testid="att-image" placeholder="Image URL (optional)" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <textarea data-testid="att-desc" placeholder="Description" rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="att-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add attraction</button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((a) => (
          <div key={a.id} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-sky-600">{a.category}</div>
                <div className="font-display text-lg font-semibold mt-1">{a.name}</div>
                {a.distance && <div className="text-xs text-slate-500 mt-1">{a.distance}</div>}
              </div>
              <button data-testid={`att-del-${a.id}`} onClick={() => del(a.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
            <p className="text-sm text-slate-600 mt-2">{a.description}</p>
            {a.address && <div className="text-xs text-slate-500 mt-2">{a.address}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
